import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { updateVersion } from './global/actions'
import accountReducer from './account'
import scrapingReducer from './scraping'
import councilsReducer from './councils'
import councilsSuburbsReducer from './councils-suburbs'
import councilsListingsReducer from './councils-listings'
import councilsListingsEditReducer from './councils-listings-manage'
// import councilsListingEditReducer from './councils-listing-manage'
// import listingReducer from './councils-listing-manage'
import propertyReducer from './councils-listing-manage'
import buildingsReducer from './buildings'
import buildingsListingsReducer from './buildings-listings'
import scrapeHistoryReducer from './scrape-history'
import scrapeQueueReducer from './scrape-queue'
import events from './events'
import usersReducer from './users'
import usersListReducer from './user-listings'
import userManagementReducer from './user-management'
import loginProgressReducer from './login-progress'
import councilsAccessListReducer from './councils-access'
import buildingsAccessListReducer from './buildings-access'
// QA
import qaListReducer from './qa-properties'
import teamListReducer from './team-properties'
import qaPropertyEditReducer from './qa-property'

const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    account: accountReducer,
    scraping: scrapingReducer,
    councils: councilsReducer,
    councilsSuburbs: councilsSuburbsReducer,
    councilsListings: councilsListingsReducer,
    councilsListingsEdit: councilsListingsEditReducer,
    // councilsListingEdit: councilsListingEditReducer,
    // listing: listingReducer,
    property: propertyReducer,
    buildings: buildingsReducer,
    buildingsListings: buildingsListingsReducer,
    scrapeHistory: scrapeHistoryReducer,
    scrapeQueue: scrapeQueueReducer,
    events,
    users: usersReducer,
    usersList: usersListReducer,
    userManagement: userManagementReducer,
    loginProgress: loginProgressReducer,
    councilsAccessList: councilsAccessListReducer,
    buildingsAccessList: buildingsAccessListReducer,
    qaList: qaListReducer,
    teamList: teamListReducer,
    qaPropertyEdit: qaPropertyEditReducer,
  },
})

store.dispatch(updateVersion())

/**
 * @see https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
 */
export type AppDispatch = typeof store.dispatch
export type AppState = ReturnType<typeof store.getState>
export const useAppDispatch = () => useDispatch()

export default store
